export default __webpack_public_path__ + "static/media/kiki.17a312c3.jpg";